import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { HUB_API_SETTINGS_TOKEN } from '../../hub-api-settings-token';
import { HubApiSettingsService } from '../../hub-api-settings.service';
import { StockReport } from '../model/query/stock-report';
import { StockReportInput } from '../model/query/stock-report-input';
import { Query } from '../model/query/query';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

// Generated service for communicating with the StockReport API endpoint.
@Injectable()
export class StockReportEndpointService {

  constructor(
    private http: HttpClient,
    private settingsService: HubApiSettingsService,
  ) {}

  StockReportAsCsv(stockReport: StockReport): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: stockReport,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Stock/ReportToCSV',
      options);
  }

  GetReportFromFilter(filter: StockReportInput): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: filter,
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Stock/Filter/Report',
      options);
  }
}
